import React from 'react';
import './BrandedInput.css';

interface BrandedInputProps {
  type?: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  className?: string;
}

/**
 * Branded input component with label and error handling
 */
export const BrandedInput: React.FC<BrandedInputProps> = ({
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  label,
  error,
  required = false,
  disabled = false,
  autoComplete,
  className = '',
}) => {
  const inputId = `input-${name}`;
  const errorId = `${inputId}-error`;

  return (
    <div className={`branded-input-wrapper ${className}`}>
      {label && (
        <label htmlFor={inputId} className="branded-input-label">
          {label}
          {required && (
            <span className="branded-input-required" aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        className={`branded-input ${error ? 'branded-input--error' : ''}`}
      />
      {error && (
        <span id={errorId} className="branded-input-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};
